import { LicenseMainFormWebComponent } from './component/LicenseMainFormWebComponent';
import { WEB_COMPONENT_LICENSE_MAIN_FORM } from '../../webcomponents.constants';

export { LicenseMainFormWebComponent };

window.customElements.define(WEB_COMPONENT_LICENSE_MAIN_FORM, LicenseMainFormWebComponent);
